export default "__VITE_ASSET__CTbO9XT0__"